export default {
  common: {
    loadFailed: "Unable to load. Please retry.",
    saveFailed: "Unable to save. Please retry.",
    refresh: 'Refresh',
    search: 'Search',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    disable: 'Disable',
    view: 'View',
    share: 'Share',
    shared: 'Shared',
    revoke: 'Revoke',
    authorize: 'Authorize',
    actions: 'Actions',
    all: 'All',
    readOnly: 'Read-only',
    collaboration: 'Collaborate',
    normal: 'Active',
    disabled: 'Disabled',
    enabled: 'Enabled',
    closed: 'Off',
    noData: 'No data',
    notFilled: 'Not provided',
    unassigned: 'Unassigned',
    unknownOrganization: 'Unknown organization',
    selectOrganization: 'Select organization',
    includeChildren: 'Include child organizations',
    description: 'Description',
    remarks: 'Remarks',
    organization: 'Organization',
    owningOrganization: 'Organization',
    loginName: 'Login name',
    nickname: 'Nickname',
    phone: 'Phone',
    role: 'Role',
    status: 'Status',
    permission: 'Permission',
    validThrough: 'Valid through',
    device: 'Device',
    deviceName: 'Device name',
    chipId: 'Chip ID',
    deviceType: 'Device type',
    hardwareVersion: 'Hardware version',
    softwareVersion: 'Software version',
    type: 'Type',
    owner: 'Owner',
    deviceKeywordPlaceholder: 'Device name, description, or chip ID',
    selectUser: 'Select a user',
    saveSuccess: 'Saved successfully',
    authorizationSuccess: 'Authorization granted',
    operationConfirm: 'Confirm operation',
    revoked: 'Revoked'
  },
  theme: {
    title: 'Organization Themes',
    keywordPlaceholder: 'Theme name, description, or FourCC',
    themeName: 'Theme name',
    editTitle: 'Edit Theme Metadata',
    shareTitle: 'Share Theme',
    exactPhone: 'Enter the full phone number with country code for overseas users (any organization)',
    selectOrgUser: 'Select a user in the theme organization',
    confirmRevoke: 'Revoke this theme relationship?'
  },
  management: {
    title: 'Organization Management',
    peopleManagement: 'User Management',
    visibleOrganizations: 'Visible organizations',
    currentOrganization: 'Current organization',
    addChild: 'Add child',
    organizationCode: 'Organization code',
    level: 'Level',
    path: 'Path',
    childOrganizations: 'Child organizations',
    dragToSort: 'Drag rows to reorder siblings',
    saveOrder: 'Save order',
    dragSort: 'Drag to reorder',
    noChildren: 'No child organizations',
    selectLeftOrganization: 'Select an organization on the left',
    editTitle: 'Edit Organization',
    createTitle: 'Add Organization',
    organizationName: 'Organization name',
    parentOrganization: 'Parent organization',
    autoGenerated: 'Generated automatically',
    enterOrganizationName: 'Enter an organization name',
    deleteConfirmMessage: 'Before deleting, confirm that the organization has no users, devices, or themes.',
    deleteConfirmTitle: 'Confirm deletion',
    deleteSuccess: 'Deleted successfully',
    orderSaved: 'Order saved',
    moveParent: 'Move parent',
    moveTitle: 'Change organization parent',
    moveSource: 'Organization',
    moveTarget: 'New parent',
    moveTargetPlaceholder: 'Filter by organization name',
    selectedTarget: 'Selected parent',
    moveReason: 'Reason',
    moveReasonPlaceholder: 'Optional reason for this change',
    previewImpact: 'Preview impact',
    confirmMove: 'Confirm move',
    moveBlocked: 'This move cannot be executed',
    moveSummary: 'Impact preview',
    currentPath: 'Current path',
    newPath: 'New path',
    nodes: 'Organizations',
    users: 'Users',
    boards: 'Devices',
    themes: 'Themes',
    affectedSubadmins: 'Affected sub-admins',
    selectMoveTarget: 'Select a new parent organization',
    moveConfirmMessage: 'Move this organization and all descendants to the new parent? User, device, theme ownership and independent grants will not be changed.',
    moveSuccess: 'Organization parent updated'
  },
  users: {
    title: 'Organization Users',
    addUser: 'Add user',
    organizationScope: 'Organization scope',
    keywordPlaceholder: 'Login name, nickname, or phone',
    accountStatus: 'Account status',
    changeOrganization: 'Change organization',
    resetPassword: 'Reset password',
    editTitle: 'Edit User',
    createTitle: 'Add User',
    password: 'Password',
    keepPasswordPlaceholder: 'Leave blank to keep unchanged',
    passwordPlaceholder: 'Enter password',
    confirmPassword: 'Confirm password',
    selectRole: 'Select role',
    dataScope: 'Data scope',
    moveTitle: 'Change User Organization',
    person: 'User',
    targetOrganization: 'Target organization',
    detailsTitle: 'User Details',
    scopeCalculatedByServer: 'Calculated by the server for this role',
    selectTargetOrganization: 'Select a target organization',
    organizationChanged: 'Organization updated',
    completeUserInfo: 'Complete all required user information',
    saveFailed: 'Failed to save user',
    passwordMismatch: 'The passwords do not match',
    enterNewPassword: 'Enter a new password',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordResetSuccess: 'Password reset',
    disableConfirm: 'This account will no longer be able to sign in. Continue?',
    accountDisabled: 'Account disabled'
  },
  roles: {
    title: 'Roles & Permissions',
    builtinRoles: 'Built-in roles',
    code: 'Code',
    permissionPoints: 'Permissions',
    group: 'Group',
    permissionCode: 'Permission code',
    name: 'Name',
    roleHasPermission: 'Granted to role',
    description: 'Description'
  },
  myBoards: {
    title: 'My Boards',
    owned: 'Owned',
    relationship: 'Relationship',
    capability: 'Capability',
    operable: 'Operable',
    noValidRelations: 'No valid device relationships', renameTitle: 'Rename board', nameRequired: 'Enter a board name', renamed: 'Board name updated'
  },
  orgBoards: {
    internalUsers: "Organization users",
    externalUsers: "External collaborators",
    source: "Source",
    legacySource: "Existing relationship",
    permanent: "No expiration",
    expired: "Expired",
    editAuthorization: "Edit Device Access",
    exactPhone: "Full phone number with country code (e.g. +86)",
    futureExpiry: "Expiration must be in the future",
    confirmExternal: "Grant {user} access to \"{board}\"? Permission: {permission}. Expiration: {expiry}. Any existing grant will be updated.",
    title: 'Organization Devices',
    multipleOwners: 'Multiple owners',
    ownerUnavailable: 'Owner unavailable',
    managementCapability: 'Management capability',
    userRelations: 'User relationships',
    organizationAssignment: 'Organization assignment',
    manageRelations: 'Manage relationships',
    transferOwner: 'Transfer owner',
    relationsTitle: 'Device User Relationships',
    selectOrganizationUser: 'Select a user in the organization',
    transferOwnerTitle: 'Transfer Device Owner',
    newOwner: 'New owner',
    selectDeviceOrgUser: 'Select a user in the device organization',
    confirmTransfer: 'Confirm transfer',
    changeDeviceOrganization: 'Change Device Organization',
    confirmRevoke: 'Revoke this device relationship?',
    assignOrganizationFirst: 'Assign the device to an organization first',
    selectNewOwner: 'Select a new owner',
    ownerUpdated: 'Owner updated',
    organizationUpdated: 'Organization updated', renameTitle: 'Rename board', nameRequired: 'Enter a board name', renamed: 'Board name updated'
  },
  platformBoards: {
    title: 'Platform Device Operations',
    addDevice: 'Add device',
    taskLimit: 'Task limit',
    sessionLimit: 'Session limit',
    usedSessions: 'Used sessions',
    bootCount: 'Boot count',
    autoUpgrade: 'Auto upgrade',
    platformValidity: 'Platform validity',
    lastOnline: 'Last online',
    assignOwner: 'Assign owner',
    reboot: 'Reboot',
    refurbish: 'Refurbish',
    editTitle: 'Edit Platform Device',
    createTitle: 'Add Platform Device',
    deviceDescription: 'Device description',
    maxTasks: 'Maximum tasks',
    longTermPlaceholder: 'Leave blank for no expiration',
    enterChipId: 'Enter the chip ID',
    enterDeviceName: 'Enter the device name',
    deviceUpdated: 'Device updated',
    deviceCreated: 'Device created',
    enterTargetUserUid: 'Enter the target user UID',
    assignOwnerTitle: 'Assign Device Owner',
    targetUserUidRequired: 'Target user UID is required',
    rebootConfirm: 'Reboot this device?',
    rebootSent: 'Reboot command sent',
    refurbishConfirm: 'Refurbishing clears device relationships, theme snapshots, and run records. Continue?',
    highRiskOperation: 'High-risk operation',
    deviceRefurbished: 'Device refurbished',
    deleteConfirm: 'Deleting clears device relationships, theme snapshots, and run records. Continue?',
    deviceDeleted: 'Device deleted',
    manageCapabilities: 'Board capabilities',
    capabilityDescription: 'This only grants access to the valid-through date and administrator parameters. It does not change ownership or collaboration relationships.',
    capabilityUser: 'Authorized user',
    capabilityType: 'Capability',
    boardAdminParamsCapability: 'Administrator parameters',
    capabilityGranted: 'Capability granted',
    revokeCapabilityConfirm: 'Revoke this user\'s administrator-parameter capability?'
  },
  deviceTypes: {
    controlV5: 'Controller V5',
    controlV3: 'Controller V3',
    SNA: 'SNA',
    SNIO: 'SNIO',
    SNU: 'SNU',
    phone: 'Phone'
  },
  roleNames: {
    sivaadmin: 'System administrator',
    admin: 'System administrator',
    subadmin: 'Sub-administrator',
    koradmin: 'Sub-administrator',
    store_manager: 'Store manager',
    employee: 'Employee',
    platform_staff: 'Platform operations staff'
  },
  dataScopes: {
    ALL: 'All organizations',
    ORG_AND_CHILDREN: 'Current and child organizations',
    SELF_ORG: 'Current organization'
  },
  permissionGroups: {
    org: 'Organization',
    user: 'Users',
    board: 'Devices',
    platform: 'Platform',
    theme: 'Themes',
    role: 'Roles'
  },
  permissionNames: {
    org_view: 'View organizations',
    org_create: 'Create organizations',
    org_update: 'Update organizations',
    org_delete: 'Delete organizations',
    org_sort: 'Sort organizations',
    org_move: 'Change organization parent',
    user_view: 'View users',
    user_create: 'Create users',
    user_update: 'Update users',
    user_delete: 'Delete users',
    user_disable: 'Disable users',
    user_password_reset: 'Reset passwords',
    user_role_set: 'Set user roles',
    user_org_move: 'Change user organization',
    board_own_view: 'View my devices',
    board_org_view: 'View organization devices',
    board_org_set: 'Set device organization',
    board_user_set: 'Set device users',
    board_external_share_set: 'Share devices externally',
    board_owner_transfer: 'Transfer device owner',
    board_capability_set: 'Set board capability',
    platform_board_ops: 'Platform device operations',
    theme_view: 'View themes',
    theme_org_view: 'View organization themes',
    theme_edit: 'Edit themes',
    theme_user_set: 'Set theme users',
    role_view: 'View roles',
    role_create: 'Create roles',
    role_update: 'Update roles',
    role_delete: 'Delete roles',
    permission_view: 'View permissions'
  },
  permissionDescriptions: {
    org_view: 'View the organization tree',
    org_create: 'Create organizations',
    org_update: 'Update organization details',
    org_delete: 'Delete an organization when it is unused',
    org_sort: 'Drag to reorder sibling organizations',
    org_move: 'Move an organization and recalculate descendant paths',
    user_view: 'View users within the organization scope',
    user_create: 'Create users within the organization scope',
    user_update: 'Update users within the organization scope',
    user_delete: 'Delete or disable users within the organization scope',
    user_disable: 'Disable user sign-in',
    user_password_reset: 'Reset user passwords',
    user_role_set: 'Assign user roles',
    user_org_move: 'Change the organization assigned to a user',
    board_own_view: 'View owned and shared devices',
    board_org_view: 'View devices by organization scope',
    board_org_set: 'Set the device organization',
    board_user_set: 'Set device user relationships',
    board_external_share_set: 'Share a device by exact phone number',
    board_owner_transfer: 'Transfer device ownership',
    board_capability_set: 'Grant or revoke an independent board capability',
    platform_board_ops: 'Perform platform-level device operations',
    theme_view: 'View themes by user relationship',
    theme_org_view: 'View themes by organization scope',
    theme_edit: 'Edit themes according to relationship and permission',
    theme_user_set: 'Set theme user relationships',
    role_view: 'View roles',
    role_create: 'Create custom roles',
    role_update: 'Update custom roles',
    role_delete: 'Delete custom roles',
    permission_view: 'View the permission dictionary'
  }
}
